import styled from "styled-components";
import { paletas } from "../../../../../styles/theme";

export const WrapperAlgoritmos = styled.div`
  margin: 0 0 20px;
`;

export const Wrapper = styled.div`
  h3,
  p,
  span {
    font-size: 1rem;
    font-family: "Bebas Neue", cursive;
    font-family: "Open Sans", sans-serif;
    font-family: "Poppins", sans-serif;
  }

  .no-select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently */
  }

  h3 {
    margin-bottom: 20px;
  }

  .indenta {
    padding-left: 15px;
  }

  .indenta2 {
    padding-left: 30px;
  }
`;

export const EVariavel = styled.span`
  color: ${paletas.BlueLight};
`;

export const ESistema = styled.span`
  color: ${paletas.OrangeVivid};
`;

export const EFuncao = styled.span`
  color: ${paletas.OrangeDesaturado};
`;

export const EParametro = styled.span`
  color: ${paletas.DarkOrange};
`;

export const ETimer = styled.div`
  font-size: 0.85rem;
  text-align: right;

  span {
    font-size: 1.25rem;
    color: ${paletas.OrangeDesaturado};
  }
`;
